<template>
  <div class="people-track">
    <div :class="{'disabled': pgnnpAudioMode}" class="btn-player" @click="!pgnnpAudioMode ? playTrack() : null">
      <PlayerStaticPlayBtn :width="clientWidth < 1024 ? 71 : 80" :height="clientWidth < 1024 ? 71 : 80" :disabled="pgnnpAudioMode" />
      <!-- <svg :width="clientWidth < 1024 ? 71 : 80"
           :height="clientWidth < 1024 ? 71 : 80"
           class="static player-btn" viewBox="0 0 80 80"
      >
        <circle class="circle-base" cx="40" cy="40" r="38" />
        <path class="play-btn" d="M31.93 52.033V27.967a3.059 3.059 0 0 1 4.844-2.482l16.723 12.032a3.059 3.059 0 0 1 0 4.966L36.774 54.515a3.059 3.059 0 0 1-4.845-2.482z" />
      </svg> -->
    </div>
    <div class="name">
      <RouterLink v-if="labelId" :to="{ name: 'composerById', params: { locale: $i18n.localePath(), id: labelId }}"
                  class="label" tag="p"
      >
        {{ label }}
      </RouterLink>
      <p v-else-if="label" class="label">
        {{ label }}
      </p>
      <h1 v-if="title" class="title">
        {{ title }}
      </h1>
    </div>
    <div class="btn-group">
      <a class="mk-btn mk-btn--secondary" @click="$emit('add-to-playlist')">
        <i class="material-icons">
          add_circle_outline
        </i>{{ $t('TRACK.ADD_TO_PLAYLIST') }}
      </a>
      <a class="mk-btn mk-btn--secondary" @click="$emit('open-share-track')">
        <i class="material-icons">
          share
        </i>{{ $t('COMMON.SHARE') }}
      </a>
    </div>
    <p v-if="alias !== ''" class="alias">
      {{ aliasTitle }} : {{ alias }}
    </p>
    <div class="performer-list">
      <ul>
        <li v-for="(performer, index) in performerDate" :key="index">
          {{ displayPerformerPosition(performer.position) + '： ' }}
          <RouterLink :to="{ name: 'performerById', params: { locale: $i18n.localePath(), id: index }}">
            {{ displayPerformerName(performer) }}
          </RouterLink>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import PlayerStaticPlayBtn from '@/components/player/PlayerStaticPlayBtn'
import { displayPerformerName, displayPerformerPosition } from '@/assets/helpers/TrackHelper'
import { getCookie } from '@/assets/helpers/UtilHelper'

export default {
  components: {
    PlayerStaticPlayBtn
  },
  props: {
    'title': {
      type: String,
      default: ''
    },
    'aliasTitle': {
      type: String,
      default: ''
    },
    'alias': {
      type: String,
      default: ''
    },
    'label': {
      type: String,
      default: ''
    },
    'labelId': {
      type: String,
      default: ''
    },
    'performerDate': {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      pgnnpAudioMode: state => state.player.pgnnpAudioMode,
      isAnyPgnnpAudio: state => state.player.isAnyPgnnpAudio,
      currentTime: state => state.player.currentTime,
      paused: state => state.player.paused
    }),
    locale() {
      return this.$i18n.locale.toLowerCase()
    },
    clientWidth() {
      return this.$store.state.clientWidth
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    displayPerformerName,
    displayPerformerPosition,
    getCookie,
    playTrack() {
      const isFirstPlay = this.getCookie('player_play_count') === null
      if (isFirstPlay) {
        this.$store.commit('SET_TO_PREPEND', true)
        this.$store.dispatch('PGNNP_AUDIO_NEXT')
        this.$nextTick(() => {
          this.$store.commit('TOGGLE_PLAYER_PAUSED', false) // trigger auto play
        })
        if (!this.isAnyPgnnpAudio) {
          document.querySelector('#audioPlayer').play()
          document.querySelector('#audioPlayer').pause()
        }
      } else if (!this.paused || this.currentTime > 0) {
        this.$store.dispatch('INCREASE_PLAYING_COUNT')
        this.$nextTick(() => {
          this.$store.commit('TOGGLE_PLAYER_PAUSED', false) // trigger auto play
        })
      }
      this.$emit('play-track')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/component/button.scss';

.people-track{
  .btn-player{
    display: inline-block;
    position: relative;
    width: 77px;
    height: 77px;
    vertical-align: middle;
    float: left;
    cursor: pointer;
    margin-bottom: 18px;
    .circle-base {
      fill: none;
      stroke: $grey-ec;
      stroke-width: 3px;
      fill: #fff;
    }
    .play-btn {
      fill: $grey-50;
      transition: all .3s;
    }
    &.disabled{
      user-select: none;
      cursor: not-allowed;
    }
    &:hover{
      .play-btn {
        fill: $grey-9b;
      }
    }
  }
  .name{
    overflow: hidden;
    padding-left: 24px;
    .title{
      font-size: 24px;
      font-weight: 500;
      line-height: 1.6;
      color: $grey-50;
      margin: 0;
      padding: 0;
    }
    .sub-title{
      font-size: 16px;
      font-weight: bold;
      line-height: 1.6;
      color: $grey-9b;
      margin: 0;
    }
    .label{
      display: inline;
      font-size: 16px;
      font-weight: bold;
      line-height: 1.6;
      color: $grey-9b;
      margin: 0 0 4px;
      cursor: pointer;
    }
    &:after{
      content: "";
      display: block;
      clear: both;
    }
  }
  .alias{
    display: block;
    font-size: 16px;
    font-weight: bold;
    line-height: 1.6;
    color: $grey-7d;
    margin: 16px 0;
    &:before{
      content: "";
      display: block;
      clear: both;
    }
  }
  .btn-group{
    display: block;
    margin: 16px 0 18px;
    .mk-btn{
      float: left;
      width: calc(50% - 7.5px);
      margin-right: 7.5px;
      i{
        position: relative;
        vertical-align: middle;
        top: -2px;
        font-size: 20px;
        margin-right: 8px;
      }
      &+.mk-btn{
        margin-right: 0;
        margin-left: 7.5px;
      }
    }

    &:before,
    &:after{
      content: "";
      display: block;
      clear: both;
    }
  }
  .performer-list{
    margin-bottom: 36px;
    ul{
      list-style: none;
      padding: 0;
      margin: 0;
      li{
        font-size: 16px;
        font-weight: bold;
        line-height: 1.6;
        color: $grey-7d;
        margin-bottom: 1px;
        a{
          color: $link-hover;
          text-decoration: none;
        }
      }
    }
  }
}

@media only screen and (max-width: 1023.98px) {
  .people-track{
    .photo{
      width: 71px;
      height: 71px;
    }
    .name{
      padding-left: 8px;
      .title{
        font-size: 16px;
      }
      .sub-title,
      .label{
        font-size: 14px;
      }
    }
    .btn-group{
      .mk-btn{
        font-size: 16px;
        i{
          font-size: 18px;
          margin-right: 4px;
        }
      }
    }
  }
}

@media only screen and (max-width: 767.98px) {
  .people-track{
    margin-bottom: 16px;
    .alias{
      color: $grey-9b;
      margin-bottom: 16px;
    }
  }
}

</style>
